"use client";

import { CcSeoProcess } from "@/components/services/seo/CcSeoProcess";
import type { SeoPageCopy } from "@/components/services/seo/seo-page-copy";

import { HUBSPOT_PROCESS_ILLUSTRATIONS } from "./hubspot-process-illustrations";

/**
 * Four-step process band for the HubSpot sub-page. Client wrapper because
 * illustration components cannot be passed from the server view.
 */
export function CcHubSpotProcess({ copy }: { copy: SeoPageCopy["process"] }) {
  return <CcSeoProcess copy={copy} illustrations={HUBSPOT_PROCESS_ILLUSTRATIONS} />;
}
